import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { sectors } from '../data/siteData';
import './Expertise.css';

const Expertise = () => {
  return (
    <section className="expertise" id="sectors">
      <div className="expertise-container">
        <div className="expertise-left">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-label">SECTOR EXPERTISE</span>
            <h2 className="section-title">
              Deep Industry
              <br />
              <span className="title-accent">Knowledge</span>
            </h2>
            <p className="expertise-text">
              Our sector-focused approach combines legal excellence with deep
              industry understanding. We do not just know the law; we know your business,
              your challenges, and your opportunities.
            </p>
            <div className="expertise-features">
              <div className="feature-item">
                <div className="feature-icon">1</div>
                <div className="feature-content">
                  <h4>Industry Leaders</h4>
                  <p>Recognized experts in every major sector</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">2</div>
                <div className="feature-content">
                  <h4>Market Intelligence</h4>
                  <p>Real-time insights and trend analysis</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">3</div>
                <div className="feature-content">
                  <h4>Strategic Partnerships</h4>
                  <p>Connected to industry leaders worldwide</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="expertise-right">
          <div className="sectors-grid">
            {sectors.map((sector, index) => (
              <motion.div
                key={sector.title}
                className="sector-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.02 }}
              >
                <div className="sector-header">
                  <div className="sector-image">{sector.icon}</div>
                  <div className="sector-metric">{sector.metric}</div>
                </div>
                <h3 className="sector-title">{sector.title}</h3>
                <p className="sector-description">{sector.summary}</p>
                <div className="sector-footer">
                  <Link to={`/sectors/${sector.slug}`} className="sector-link">
                    Explore Sector
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;
